import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (sessionStorage.getItem(environment.tokenSessionName)) {
            request = request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + sessionStorage.getItem(environment.tokenSessionName))
            });
        }

        if (!request.url.includes('media') && (request.method === 'PUT' || request.method === 'POST')) {
            if (request.body && !(request.body instanceof FormData)) {
                request = request.clone({
                    body: this.getBodyHttp(request.body)
                });
            }
        }

        return next.handle(request);
    }

    getBodyHttp(datum: any = {}) {
        return Object.keys(datum).reduce((acc, key) => {
            switch (key) {
                case 'createdAt':
                case 'deletedAt':
                case 'deploymentDoneAt':
                case 'deploymentStartedAt':
                case 'endAt':
                case 'expiresAt':
                case 'lastConnection':
                case 'lastLogCreatedAt':
                case 'lastSync':
                case 'nextEvent':
                case 'registrationEndAt':
                case 'registrationStartAt':
                case 'startAt':
                case 'subscriptionDate':
                case 'subscriptionDeadline':
                case 'synchronizedAt':
                case 'updatedAt':
                case 'validatedAt':
                    if (datum[key] && !isNaN(new Date(datum[key]) as any)) {
                        datum[key] = new Date(datum[key]).toISOString();
                    }
                    break;
            }

            if (datum[key] && typeof datum[key] === 'object' && datum[key] instanceof Object && !Array.isArray(datum[key])) {
                datum[key] = this.getBodyHttp(datum[key]);
            }

            if (datum[key] && typeof datum[key] === 'object' && datum[key] instanceof Array && Array.isArray(datum[key])) {
                datum[key] = (datum[key] as Array<any>).reduce((accTemp, item) => {
                    const d = item instanceof Object ? this.getBodyHttp(item) : item;
                    return [...accTemp, d];
                }, []);
            }

            return { ...acc, [key]: datum[key] };
        }, {});
    }
}
